import { useCallback } from 'react';
import { useLenis } from 'lenis/react';

export function useScrollTo() {
  const lenis = useLenis();
  return useCallback(
    (id) => {
      if (!lenis) {
        if (!id) window.scrollTo({ top: 0, behavior: 'smooth' });
        else document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        return;
      }
      if (!id) lenis.scrollTo(0, { duration: 1.2 });
      else lenis.scrollTo(`#${id}`, { offset: -64, duration: 1.4 });
    },
    [lenis],
  );
}
